;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { compact } from "lodash-es";

type SharedViewListFilters = {
	viewId?: string;
	workspaceId?: string;
};

type SharedViewPublicWorkspaceKeyParams = {
	email?: string | null;
	sessionToken?: string | null;
	shouldFilterByPropertyGroupIds: boolean;
	slug: string;
	visibility?: string | null;
};

export interface SharedViewVisualizationQueryIdentity {
	sessionToken?: string;
	slug: string;
	viewVisualizationId: string;
	viewerEmail?: string;
	visualizationName: string;
}

type SharedViewVisualizationSuffix = {
	globalDataProvider?: string | null;
	globalDateRange?: string | null;
	leaderboardPartitionKey?: string | null;
	transformParamsKey: string;
};

type SharedViewPublicVisualizationKeyParams = {
	sessionToken?: string | null;
	slug: string;
	transformParams?: unknown;
	viewVisualizationId?: string;
	viewerEmail?: string | null;
	visualizationName?: string;
};

export const sharedViewQueryKeys = {
	all: ["shared-views"] as const,
	detail: (id: string) => [...sharedViewQueryKeys.details(), id] as const,
	details: () => [...sharedViewQueryKeys.all, "detail"] as const,
	list: (filters: SharedViewListFilters) =>
		[...sharedViewQueryKeys.lists(), filters] as const,
	lists: () => [...sharedViewQueryKeys.all, "list"] as const,
	publicBySlug: (slug: string) => ["shared-view", slug] as const,
	publicByToken: (token: string) =>
		[...sharedViewQueryKeys.all, "public", token] as const,
	publicVisualization: ({
		sessionToken,
		slug,
		transformParams,
		viewVisualizationId,
		viewerEmail,
		visualizationName,
	}: SharedViewPublicVisualizationKeyParams) =>
		compact([
			...sharedViewQueryKeys.publicBySlug(slug),
			"visualization",
			viewVisualizationId ?? visualizationName ?? "unknown",
			transformParams,
			viewerEmail ?? null,
			sessionToken ?? null,
		]),
	publicWorkspaceProperties: ({
		email,
		sessionToken,
		shouldFilterByPropertyGroupIds,
		slug,
		visibility,
	}: SharedViewPublicWorkspaceKeyParams) =>
		[
			"shared-view",
			"public",
			slug,
			"workspace",
			"properties",
			{
				email: email ?? null,
				sessionToken: sessionToken ?? null,
				shouldFilterByPropertyGroupIds,
				visibility,
			},
		] as const,
	publicWorkspacePropertyGroups: ({
		email,
		sessionToken,
		shouldFilterByPropertyGroupIds,
		slug,
		visibility,
	}: SharedViewPublicWorkspaceKeyParams) =>
		[
			"shared-view",
			"public",
			slug,
			"workspace",
			"property-groups",
			{
				email: email ?? null,
				sessionToken: sessionToken ?? null,
				shouldFilterByPropertyGroupIds,
				visibility,
			},
		] as const,
	visualization: ({
		identity,
		suffix,
	}: {
		identity: SharedViewVisualizationQueryIdentity;
		suffix: SharedViewVisualizationSuffix;
	}) =>
		compact([
			...sharedViewQueryKeys.visualizationPrefix(identity),
			suffix.globalDataProvider,
			suffix.transformParamsKey,
			suffix.globalDateRange,
			suffix.leaderboardPartitionKey,
		]),
	visualizationPrefix: (identity: SharedViewVisualizationQueryIdentity) =>
		compact([
			"shared-view-visualization",
			identity.slug,
			identity.viewerEmail,
			identity.sessionToken ?? null,
			identity.viewVisualizationId,
			identity.visualizationName,
		]),
	visualizationRoot: ["shared-view-visualization"] as const,
};
